import { peaksToXY } from './peaksToXY';
export function peakToXY(peak, options = {}) {
    return peaksToXY([peak], options);
}
//# sourceMappingURL=peakToXY.js.map